/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BlogPostShowResponse2 } from '../../models/blog-post-show-response-2';

export interface DeleteBlogPostRemove$Params {
  name: string;
}

export function deleteBlogPostRemove(http: HttpClient, rootUrl: string, params: DeleteBlogPostRemove$Params, context?: HttpContext): Observable<StrictHttpResponse<BlogPostShowResponse2>> {
  const rb = new RequestBuilder(rootUrl, deleteBlogPostRemove.PATH, 'delete');
  if (params) {
    rb.path('name', params.name, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BlogPostShowResponse2>;
    })
  );
}

deleteBlogPostRemove.PATH = '/v1/blog-post/{name}';
